var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseAdministrator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0554 12.6867C17.2785 12.6867 19.0807 10.8845 19.0807 8.66142C19.0807 6.43829 17.2785 4.63609 15.0554 4.63609C12.8322 4.63609 11.03 6.43829 11.03 8.66142C11.03 10.8845 12.8322 12.6867 15.0554 12.6867Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16C22.533 16 24.4777 20.9533 24.9797 23.5105C25.1403 24.3286 24.3278 25 23.3081 25H6.6919C5.67224 25 4.85974 24.3286 5.02033 23.5105C5.52229 20.9533 7.46688 16 15 16Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAdministrator);
export default __webpack_public_path__ + "static/media/CollapseAdministrator.9234e1c81c175664d01d680dbbb162bd.svg";
export { ForwardRef as ReactComponent };